import { Box, Grid, Paper, Tabs, Tab, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const AuditNav = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [value, setValue] = useState("/audit");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = ["/audit", "/audit/logs", "/audit/requests"];
    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/audit");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%", bgcolor: "background.paper" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/audit" ? theme.palette.primary.main : "white",
                color: value === "/audit" ? "white" : "black",
              }}
              label={t("audit.dashboard")}
              value="/audit"
              component={NavLink}
              to="/audit"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/audit/logs"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/audit/logs" ? "white" : "black",
              }}
              label={t("audit.logs")}
              value="/audit/logs"
              component={NavLink}
              to="/audit/logs"
            />
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/audit/requests"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/audit/requests" ? "white" : "black",
              }}
              label={t("audit.requests")}
              value="/audit/requests"
              component={NavLink}
              to="/audit/requests"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default AuditNav;

